// extracted by mini-css-extract-plugin
export default {"project_tag":"TagLabel_project_tag__e-we8","tag_info":"TagLabel_tag_info__PEH7B"};